// extracted by mini-css-extract-plugin
export default {"MostR":"SuggestedNews_MostR__C3OWi","title":"SuggestedNews_title__4f8wp","col":"SuggestedNews_col__AU7Ra","nonFirst":"SuggestedNews_nonFirst__utBY-"};